module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Copyright-rw exclude-auto-rw page-open-auto-rw",
    attrs: {
      "epub:type": "frontmatter copyright-page",
      "id": "Copyright1"
    }
  }, [_c('div', {
    staticClass: "block-rw copyright-rw exclude-auto-rw",
    attrs: {
      "id": "copyright2"
    }
  }, [_c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p18"
    }
  }, [_c('span', [_vm._v("This book is a work of fiction. Names, characters, places, and incidents are the product of the author’s imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is coincidental.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p19"
    }
  }, [_c('span', [_vm._v("Copyright © 2016 by Seanan McGuire"), _c('br'), _vm._v("\nExcerpt from "), _c('i', [_vm._v("Into the Drowning Deep")]), _vm._v(" copyright © 2017 by Seanan McGuire")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p14"
    }
  }, [_c('span', [_vm._v("Cover design by Lauren Panepinto"), _c('br'), _vm._v("\nCover images by Shutterstock")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p20"
    }
  }, [_c('span', [_vm._v("Cover copyright © 2017 by Hachette Book Group, Inc."), _c('br'), _vm._v("\nAuthor photograph by Carolyn Billingsley")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p21"
    }
  }, [_c('span', [_vm._v("Hachette Book Group supports the right to free expression and the value of copyright. The purpose of copyright is to encourage writers and artists to produce the creative works that enrich our culture.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p22"
    }
  }, [_c('span', [_vm._v("The scanning, uploading, and distribution of this book without permission is a theft of the author’s intellectual property. If you would like permission to use material from the book (other than for review purposes), please contact permissions@hbgusa.com. Thank you for your support of the author’s rights.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p23"
    }
  }, [_c('span', [_vm._v("Orbit"), _c('br'), _vm._v("\nHachette Book Group"), _c('br'), _vm._v("\n1290 Avenue of the Americas"), _c('br'), _vm._v("\nNew York, NY 10104"), _c('br'), _c('span', {
    staticClass: "LIVELINK"
  }, [_c('a', {
    attrs: {
      "href": "http://www.orbitbooks.net",
      "target": "_blank"
    }
  }, [_vm._v("www.orbitbooks.net")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.orbitshortfiction.com",
      "target": "_blank"
    }
  }, [_vm._v("www.orbitshortfiction.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p24"
    }
  }, [_c('span', [_vm._v("Previously published in "), _c('i', [_vm._v("Rise: The Complete Newsflesh Collection ")]), _vm._v("by Mira Grant in hardcover, mass market, and ebook by Orbit in 2016"), _c('br'), _vm._v("\nFirst eBook Edition: October 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p25"
    }
  }, [_c('span', [_c('br'), _vm._v("\nOrbit is an imprint of Hachette Book Group."), _c('br'), _vm._v("\nThe Orbit name and logo are trademarks of Little, Brown Book Group Limited.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p26"
    }
  }, [_c('span', [_vm._v("The publisher is not responsible for websites (or their content) that are not owned by the publisher.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p27"
    }
  }, [_c('span', [_vm._v("The Hachette Speakers Bureau provides a wide range of authors for speaking events. To find out more, go to www.hachettespeakersbureau.com or call (866) 376-6591.")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p28"
    }
  }, [_c('span', [_vm._v("ISBN: 978-0-316-25888-3 (ebook)")])]), _vm._v(" "), _c('p', {
    staticClass: "crt-rw",
    attrs: {
      "id": "p29"
    }
  }, [_c('span', [_vm._v("E3-20170815-DANF")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28fbff4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s002-Copyright-01.vue
// module id = 63
// module chunks = 0